import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageWrap from '../components/PageWrap';
import useDocumentMeta from '../hooks/useDocumentMeta';
import routeMetaFor from '../utils/routeMeta';
import { SUPPORT_EMAIL } from '../data/siteContent';
import { PUBLISHER } from '../data/legalContent';

/**
 * Data-protection request route (task T05).
 *
 * Neutral information only: how to send a request and where each product's
 * notice lives. It must not assert compliance with a named law, a response
 * deadline, a security standard, or a studio-wide data practice.
 */
export default function DPDPA() {
  useDocumentMeta(routeMetaFor('/dpdpa'));

  return (
    <PageWrap testId="dpdpa-page">
      <Navbar />

      <section className="page-hero">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="wrap" style={{ position: 'relative', zIndex: 1 }}>
          <div className="eyebrow reveal">Legal</div>
          <h1 className="reveal d1">Data-protection requests</h1>
          <p className="lead reveal d2" data-testid="dpdpa-lead">
            How to reach us about the information a TickleApps product holds.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="wrap">
          <p className="reveal" style={{ marginBottom: 14, maxWidth: '760px' }} data-testid="dpdpa-publisher">
            TickleApps products are published by <strong>{PUBLISHER}</strong>.
          </p>
          <p className="reveal d1" style={{ marginBottom: 32, maxWidth: '760px' }}>
            Each product&apos;s own notice describes the information it handles and the services it uses. Start with the{' '}
            <Link to="/privacy">legal directory</Link> to find the notice for the app you use. This page is information
            about how to contact us, not legal advice.
          </p>

          <h2 className="reveal" style={{ marginBottom: 16, fontSize: '1.4rem' }}>Sending a request</h2>
          <p className="reveal" style={{ marginBottom: 14, maxWidth: '760px' }}>
            Email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> and include:
          </p>
          <ul className="reveal" style={{ marginBottom: 32, maxWidth: '760px' }}>
            <li style={{ padding: '7px 0', borderBottom: '1px solid var(--border)', fontSize: '0.92rem' }}>which app your request is about;</li>
            <li style={{ padding: '7px 0', borderBottom: '1px solid var(--border)', fontSize: '0.92rem' }}>what you would like us to do; and</li>
            <li style={{ padding: '7px 0', borderBottom: '1px solid var(--border)', fontSize: '0.92rem' }}>enough detail for us to identify the account, where the app has one.</li>
          </ul>
          <p className="reveal" style={{ marginBottom: 32, maxWidth: '760px' }}>
            We verify a request before acting on it. For NutriScan, send it from the Google address you use to sign in — see{' '}
            <Link to="/apps/nutriscan/account-deletion">NutriScan Account Deletion</Link>. CardCycle keeps its records on
            your device and has no account, so deletion happens in the app — see{' '}
            <Link to="/apps/cardcycle/account-deletion">CardCycle Data Deletion</Link>.
          </p>
        </div>
      </section>

      <Footer />
    </PageWrap>
  );
}
